import * as i0 from '@angular/core';
import * as i1 from './calendar-kit.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '../button/button.component';
import * as i6 from '../icon/icon.component';
import * as i7 from './components/calendar-header/calendar-header.component';
import * as i8 from './components/calendar-navigation/calendar-navigation.component';
import * as i9 from './components/calendar-navigation/calendar-pageable-navigation.component';
import * as i10 from './components/calendar-days-names/calendar-days-names.component';
import * as i11 from './components/calendar-year-picker/calendar-year-picker.component';
import * as i12 from './components/calendar-month-picker/calendar-month-picker.component';
import * as i13 from './components/calendar-day-picker/calendar-day-picker.component';
import * as i14 from './components/calendar-day-picker/calendar-day-cell.component';
import * as i15 from './components/calendar-month-picker/calendar-month-cell.component';
import * as i16 from './components/calendar-year-picker/calendar-year-cell.component';
import * as i17 from './components/calendar-picker/calendar-picker-row.component';
import * as i18 from './components/calendar-picker/calendar-picker.component';
import * as i19 from './components/calendar-week-number/el-calendar-week-number.component';
import * as i20 from '../shared/shared.module';
import * as i21 from '../button/button.module';
import * as i22 from '../icon/icon.module';
export const ElCalendarKitModuleNgFactory:i0.NgModuleFactory<i1.ElCalendarKitModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_38:i5.ElButtonComponent = (<any>(null as any));
var _decl0_39:i6.ElIconComponent = (<any>(null as any));
var _decl0_40:i7.ElCalendarHeaderComponent<any> = (<any>(null as any));
var _decl0_41:i8.ElCalendarNavigationComponent<any> = (<any>(null as any));
var _decl0_42:i9.ElCalendarPageableNavigationComponent<any> = (<any>(null as any));
var _decl0_43:i10.ElCalendarDaysNamesComponent<any> = (<any>(null as any));
var _decl0_44:i11.ElCalendarYearPickerComponent<any> = (<any>(null as any));
var _decl0_45:i12.ElCalendarMonthPickerComponent<any,any> = (<any>(null as any));
var _decl0_46:i13.ElCalendarDayPickerComponent<any,any> = (<any>(null as any));
var _decl0_47:i14.ElCalendarDayCellComponent<any> = (<any>(null as any));
var _decl0_48:i15.ElCalendarMonthCellComponent<any> = (<any>(null as any));
var _decl0_49:i16.ElCalendarYearCellComponent<any> = (<any>(null as any));
var _decl0_50:i17.ElCalendarPickerRowComponent<any,any> = (<any>(null as any));
var _decl0_51:i18.ElCalendarPickerComponent<any,any> = (<any>(null as any));
var _decl0_52:i19.ElCalendarWeekNumberComponent<any> = (<any>(null as any));
var _decl0_53:i2.AsyncPipe = (<any>(null as any));
var _decl0_54:i2.UpperCasePipe = (<any>(null as any));
var _decl0_55:i2.LowerCasePipe = (<any>(null as any));
var _decl0_56:i2.JsonPipe = (<any>(null as any));
var _decl0_57:i2.SlicePipe = (<any>(null as any));
var _decl0_58:i2.DecimalPipe = (<any>(null as any));
var _decl0_59:i2.PercentPipe = (<any>(null as any));
var _decl0_60:i2.TitleCasePipe = (<any>(null as any));
var _decl0_61:i2.CurrencyPipe = (<any>(null as any));
var _decl0_62:i2.DatePipe = (<any>(null as any));
var _decl0_63:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_64:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_65:i2.KeyValuePipe = (<any>(null as any));
var _decl0_66:i20.ElSharedModule = (<any>(null as any));
var _decl0_67:i21.ElButtonModule = (<any>(null as any));
var _decl0_68:i22.ElIconModule = (<any>(null as any));
var _decl0_69:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_70:i0.ElementRef<any> = (<any>(null as any));
function _View_ElCalendarHeaderComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarHeaderComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_62.transform(_decl0_40.date,'mediumDate');
  currVal_0;
  const currVal_1:any = {'el-arrow-dropright':_decl0_40.isLtr,'el-arrow-dropleft':_decl0_40.isRtl};
  currVal_1;
  const pd_2:any = ((<any>_decl0_40.navigateToday.emit()) !== false);
}
function _View_ElCalendarNavigationComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarNavigationComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38.filled;
  currVal_0;
  const currVal_1:any = _decl0_38.outline;
  currVal_1;
  const currVal_2:any = _decl0_38.ghost;
  currVal_2;
  const currVal_3:any = _decl0_38.hero;
  currVal_3;
  const currVal_4:any = _decl0_38.fullWidth;
  currVal_4;
  const currVal_5:any = _decl0_38.disabled;
  currVal_5;
  const currVal_6:any = _decl0_38.disabled;
  currVal_6;
  const currVal_7:any = _decl0_38.tabbable;
  currVal_7;
  const currVal_8:any = _decl0_38.tiny;
  currVal_8;
  const currVal_9:any = _decl0_38.small;
  currVal_9;
  const currVal_10:any = _decl0_38.medium;
  currVal_10;
  const currVal_11:any = _decl0_38.large;
  currVal_11;
  const currVal_12:any = _decl0_38.giant;
  currVal_12;
  const currVal_13:any = _decl0_38.primary;
  currVal_13;
  const currVal_14:any = _decl0_38.info;
  currVal_14;
  const currVal_15:any = _decl0_38.success;
  currVal_15;
  const currVal_16:any = _decl0_38.warning;
  currVal_16;
  const currVal_17:any = _decl0_38.danger;
  currVal_17;
  const currVal_18:any = _decl0_38.rectangle;
  currVal_18;
  const currVal_19:any = _decl0_38.round;
  currVal_19;
  const currVal_20:any = _decl0_38.semiRound;
  currVal_20;
  const currVal_21:any = _decl0_38.iconLeft;
  currVal_21;
  const currVal_22:any = _decl0_38.iconRight;
  currVal_22;
  const currVal_23:any = _decl0_38.transitions;
  currVal_23;
  const currVal_24:any = _decl0_62.transform(_decl0_41.date,'MMM yyyy');
  currVal_24;
  const pd_25:any = ((<any>_decl0_38.onClick(_any)) !== false);
  const pd_26:any = ((<any>_decl0_41.changeMode.emit()) !== false);
}
function _View_ElCalendarPageableNavigationComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarPageableNavigationComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'small';
  currVal_0;
  const currVal_1:any = '';
  currVal_1;
  const currVal_2:any = _decl0_38.filled;
  currVal_2;
  const currVal_3:any = _decl0_38.outline;
  currVal_3;
  const currVal_4:any = _decl0_38.ghost;
  currVal_4;
  const currVal_5:any = _decl0_38.hero;
  currVal_5;
  const currVal_6:any = _decl0_38.fullWidth;
  currVal_6;
  const currVal_7:any = _decl0_38.disabled;
  currVal_7;
  const currVal_8:any = _decl0_38.disabled;
  currVal_8;
  const currVal_9:any = _decl0_38.tabbable;
  currVal_9;
  const currVal_10:any = _decl0_38.tiny;
  currVal_10;
  const currVal_11:any = _decl0_38.small;
  currVal_11;
  const currVal_12:any = _decl0_38.medium;
  currVal_12;
  const currVal_13:any = _decl0_38.large;
  currVal_13;
  const currVal_14:any = _decl0_38.giant;
  currVal_14;
  const currVal_15:any = _decl0_38.primary;
  currVal_15;
  const currVal_16:any = _decl0_38.info;
  currVal_16;
  const currVal_17:any = _decl0_38.success;
  currVal_17;
  const currVal_18:any = _decl0_38.warning;
  currVal_18;
  const currVal_19:any = _decl0_38.danger;
  currVal_19;
  const currVal_20:any = _decl0_38.rectangle;
  currVal_20;
  const currVal_21:any = _decl0_38.round;
  currVal_21;
  const currVal_22:any = _decl0_38.semiRound;
  currVal_22;
  const currVal_23:any = _decl0_38.iconLeft;
  currVal_23;
  const currVal_24:any = _decl0_38.iconRight;
  currVal_24;
  const currVal_25:any = _decl0_38.transitions;
  currVal_25;
  const currVal_26:any = (_decl0_42.isLtr? 'chevron-left-outline': 'chevron-right-outline');
  currVal_26;
  const currVal_27:any = 'endlessjs-essentials';
  currVal_27;
  const currVal_28:any = _decl0_39.html;
  currVal_28;
  const currVal_29:any = _decl0_39.primary;
  currVal_29;
  const currVal_30:any = _decl0_39.info;
  currVal_30;
  const currVal_31:any = _decl0_39.success;
  currVal_31;
  const currVal_32:any = _decl0_39.warning;
  currVal_32;
  const currVal_33:any = _decl0_39.danger;
  currVal_33;
  const currVal_34:any = _decl0_42.date;
  currVal_34;
  const currVal_35:any = 'small';
  currVal_35;
  const currVal_36:any = '';
  currVal_36;
  const currVal_37:any = _decl0_38.filled;
  currVal_37;
  const currVal_38:any = _decl0_38.outline;
  currVal_38;
  const currVal_39:any = _decl0_38.ghost;
  currVal_39;
  const currVal_40:any = _decl0_38.hero;
  currVal_40;
  const currVal_41:any = _decl0_38.fullWidth;
  currVal_41;
  const currVal_42:any = _decl0_38.disabled;
  currVal_42;
  const currVal_43:any = _decl0_38.disabled;
  currVal_43;
  const currVal_44:any = _decl0_38.tabbable;
  currVal_44;
  const currVal_45:any = _decl0_38.tiny;
  currVal_45;
  const currVal_46:any = _decl0_38.small;
  currVal_46;
  const currVal_47:any = _decl0_38.medium;
  currVal_47;
  const currVal_48:any = _decl0_38.large;
  currVal_48;
  const currVal_49:any = _decl0_38.giant;
  currVal_49;
  const currVal_50:any = _decl0_38.primary;
  currVal_50;
  const currVal_51:any = _decl0_38.info;
  currVal_51;
  const currVal_52:any = _decl0_38.success;
  currVal_52;
  const currVal_53:any = _decl0_38.warning;
  currVal_53;
  const currVal_54:any = _decl0_38.danger;
  currVal_54;
  const currVal_55:any = _decl0_38.rectangle;
  currVal_55;
  const currVal_56:any = _decl0_38.round;
  currVal_56;
  const currVal_57:any = _decl0_38.semiRound;
  currVal_57;
  const currVal_58:any = _decl0_38.iconLeft;
  currVal_58;
  const currVal_59:any = _decl0_38.iconRight;
  currVal_59;
  const currVal_60:any = _decl0_38.transitions;
  currVal_60;
  const currVal_61:any = (_decl0_42.isLtr? 'chevron-right-outline': 'chevron-left-outline');
  currVal_61;
  const currVal_62:any = 'endlessjs-essentials';
  currVal_62;
  const currVal_63:any = _decl0_39.html;
  currVal_63;
  const currVal_64:any = _decl0_39.primary;
  currVal_64;
  const currVal_65:any = _decl0_39.info;
  currVal_65;
  const currVal_66:any = _decl0_39.success;
  currVal_66;
  const currVal_67:any = _decl0_39.warning;
  currVal_67;
  const currVal_68:any = _decl0_39.danger;
  currVal_68;
  const pd_69:any = ((<any>_decl0_38.onClick(_any)) !== false);
  const pd_70:any = ((<any>_decl0_42.prev.emit()) !== false);
  const pd_71:any = ((<any>_decl0_42.changeMode.emit()) !== false);
  const pd_72:any = ((<any>_decl0_38.onClick(_any)) !== false);
  const pd_73:any = ((<any>_decl0_42.next.emit()) !== false);
}
function _View_ElCalendarDaysNamesComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarDaysNamesComponent_4_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isHoliday;
  currVal_0;
  const currVal_1:any = _any.name;
  currVal_1;
}
function _View_ElCalendarDaysNamesComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.days;
  currVal_0;
}
function _View_ElCalendarYearPickerComponent_Host_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44.medium;
  currVal_0;
  const currVal_1:any = _decl0_44.large;
  currVal_1;
}
function _View_ElCalendarYearPickerComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44.years;
  currVal_0;
  const currVal_1:any = _decl0_44.year;
  currVal_1;
  const currVal_2:any = _decl0_44.date;
  currVal_2;
  const currVal_3:any = _decl0_44.cellComponent;
  currVal_3;
  const currVal_4:any = _decl0_44.min;
  currVal_4;
  const currVal_5:any = _decl0_44.max;
  currVal_5;
  const currVal_6:any = _decl0_44.filter;
  currVal_6;
  const pd_7:any = ((<any>_decl0_44.onSelect(_any)) !== false);
}
function _View_ElCalendarMonthPickerComponent_Host_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.medium;
  currVal_0;
  const currVal_1:any = _decl0_45.large;
  currVal_1;
}
function _View_ElCalendarMonthPickerComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.months;
  currVal_0;
  const currVal_1:any = _decl0_45.month;
  currVal_1;
  const currVal_2:any = _decl0_45.cellComponent;
  currVal_2;
  const currVal_3:any = _decl0_45.min;
  currVal_3;
  const currVal_4:any = _decl0_45.max;
  currVal_4;
  const currVal_5:any = _decl0_45.filter;
  currVal_5;
  const pd_6:any = ((<any>_decl0_45.onSelect(_any)) !== false);
}
function _View_ElCalendarDayPickerComponent_Host_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.medium;
  currVal_0;
  const currVal_1:any = _decl0_46.large;
  currVal_1;
}
function _View_ElCalendarDayPickerComponent_7_1():void {
  if (_decl0_46.showWeekNumber) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_46.weeks;
    currVal_0;
    const currVal_1:any = _decl0_46.size;
    currVal_1;
    const currVal_2:any = _decl0_46.weekNumberSymbol;
    currVal_2;
    const currVal_3:any = _decl0_52.isMedium;
    currVal_3;
    const currVal_4:any = _decl0_52.isLarge;
    currVal_4;
  }
}
function _View_ElCalendarDayPickerComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.showWeekNumber;
  currVal_0;
  const currVal_1:any = _decl0_46.weeks;
  currVal_1;
  const currVal_2:any = _decl0_46.visibleDate;
  currVal_2;
  const currVal_3:any = _decl0_46.date;
  currVal_3;
  const currVal_4:any = _decl0_46.cellComponent;
  currVal_4;
  const currVal_5:any = _decl0_46.min;
  currVal_5;
  const currVal_6:any = _decl0_46.max;
  currVal_6;
  const currVal_7:any = _decl0_46.filter;
  currVal_7;
  const pd_8:any = ((<any>_decl0_46.onSelect(_any)) !== false);
}
function _View_ElCalendarDayCellComponent_Host_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_47.today;
  currVal_0;
  const currVal_1:any = _decl0_47.boundingMonth;
  currVal_1;
  const currVal_2:any = _decl0_47.selected;
  currVal_2;
  const currVal_3:any = _decl0_47.empty;
  currVal_3;
  const currVal_4:any = _decl0_47.disabled;
  currVal_4;
  const pd_5:any = ((<any>_decl0_47.onClick()) !== false);
}
function _View_ElCalendarDayCellComponent_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_47.day;
  currVal_0;
}
function _View_ElCalendarMonthCellComponent_Host_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_48.selected;
  currVal_0;
  const currVal_1:any = _decl0_48.today;
  currVal_1;
  const currVal_2:any = _decl0_48.disabled;
  currVal_2;
  const pd_3:any = ((<any>_decl0_48.onClick()) !== false);
}
function _View_ElCalendarMonthCellComponent_9_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_48.month;
  currVal_0;
}
function _View_ElCalendarYearCellComponent_Host_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_49.selected;
  currVal_0;
  const currVal_1:any = _decl0_49.today;
  currVal_1;
  const currVal_2:any = _decl0_49.disabled;
  currVal_2;
  const pd_3:any = ((<any>_decl0_49.onClick()) !== false);
}
function _View_ElCalendarYearCellComponent_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_49.year;
  currVal_0;
}
function _View_ElCalendarPickerRowComponent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarPickerRowComponent_11_1():void {
  var _any:any = (null as any);
}
function _View_ElCalendarPickerRowComponent_11_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarPickerComponent_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_ElCalendarPickerComponent_12_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _decl0_51.selectedValue;
  currVal_1;
  const currVal_2:any = _decl0_51.visibleDate;
  currVal_2;
  const currVal_3:any = _decl0_51.cellComponent;
  currVal_3;
  const currVal_4:any = _decl0_51.min;
  currVal_4;
  const currVal_5:any = _decl0_51.max;
  currVal_5;
  const currVal_6:any = _decl0_51.filter;
  currVal_6;
  const pd_7:any = ((<any>_decl0_51.select.emit(_any)) !== false);
}
function _View_ElCalendarPickerComponent_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.data;
  currVal_0;
}
function _View_ElCalendarWeekNumberComponent_Host_13_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.isMedium;
  currVal_0;
  const currVal_1:any = _decl0_52.isLarge;
  currVal_1;
}
function _View_ElCalendarWeekNumberComponent_13_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
}
function _View_ElCalendarWeekNumberComponent_13_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.weekNumberSymbol;
  currVal_0;
  const currVal_1:any = _decl0_52.getWeeks();
  currVal_1;
}
